import { processQuestionSets, culturalQuestionSets, metricsQuestionSets, technicalQuestionSets, architectureQuestionSets } from './question-sets';

export const devopsCapabilitiesSample = {
  name: 'DevOps Capabilities',
  key: 'devops-capabilities',
  question_sets: [...processQuestionSets, ...culturalQuestionSets, ...metricsQuestionSets, ...technicalQuestionSets, ...architectureQuestionSets]
};

export default devopsCapabilitiesSample;
